module.exports = "/_next/static/images/9541976ad8f12281296c7dc1e0999c82-pse-payment-desktop-lg.jpg";